const MILLISECONDS_IN_ONE_DAY = 24 * 60 * 60 * 1000;

export const CHAT_FORCE_OPEN_KEY = 'newbuilding_chat/force_open';
export const CHAT_FORCE_OPEN_INTERVAL = MILLISECONDS_IN_ONE_DAY;

export const MOTIVATION_POPUP_KEY = 'newbuilding_consultant/newbuilding_listing/motivation_popup_last_shown';
export const MOTIVATION_POPUP_OPEN_INTERVAL = MILLISECONDS_IN_ONE_DAY;
